import angular from "angular";
import { FeatureToggleComponent } from "./feature-toggle.component";

/**
 * A module containing components for use when toggling feature modules.
 */
export const FeatureToggleModule = angular
    .module("apex.mainApp.shared.featureToggle", [])
    .component("apexFeatureToggle", FeatureToggleComponent)
    .name;
